import React, { Component } from 'react';
import { currentUser } from '../../services/CurrentUser'
import Routing from '../../utils/Routing'
import PubSub from 'pubsub-js';
import Constants from '../../Constants';
import EirDeviceListing from '../eir-device-listing/EirDeviceListing';
import { Container, Row } from 'reactstrap';
import CartSummary from '../cart-summary/CartSummary';
import Loading from '../shared/Loading';
import EirDropdownList from '../dropdown-list/DropdownList';
import EirMBBDeviceListing from '../eir-mbb-device-listing/EirMBBDeviceListing';
import EirHandsetCard from '../eir-handset-card/EirHandsetCard';
import EirPrepayPhoneToggle from '../eir-prepay-phone-toggle/EirPrepayPhoneToggle';



class EirDeviceListContainer extends Component {
  constructor(props) {
    super(props);
    this.modalChangedToken = null;
    this.state = {
      isLoading: false,
      userInputRequired: false,
      selectedToggleAttribute: null,
      toggleAttributes: this.getAllToggleAttributes(),
      filteredDevices: [],
      allDevices: [],
      filterOptions: [],
      sortOptions: this.getSortOptions(),
      selectedSort: (Routing.getQueryParameter('sort') ? Routing.getQueryParameter('sort').toLowerCase() : null),
      selectedFilter: (Routing.getQueryParameter('filter') ? Routing.getQueryParameter('filter').toLowerCase() : null)
    };
  }

  componentWillUnmount() {
    if (this.modalChangedToken) {
      PubSub.unsubscribe(this.modalChangedToken);
    }

    if (this.cartContentChangedToken) {
      PubSub.unsubscribe(this.cartContentChangedToken);
    }
  }

  async componentDidMount() {
    this.modalChangedToken = PubSub.subscribe(Constants.eventKeys.modalContentSelected, this.modalValueSelected);
    this.cartContentChangedToken = PubSub.subscribe(Constants.eventKeys.cartContentChanged, this.cartContentChanged);

    let selectedToggleAttribute = null;

    if (this.props.toggleAttributeName) {
      // first check the query string for a value
      let selectedToggleValue = Routing.getQueryParameter(this.props.toggleAttributeName);

      // if the query string came up with nothing, check if the user has it set
      if (selectedToggleValue == null) {
        selectedToggleValue = currentUser.getAttribute(this.props.toggleAttributeName);
      }

      this.props.deviceLists.forEach(deviceList => {
        deviceList.attributes.forEach(attribute => {
          if (attribute.name === this.props.toggleAttributeName && attribute.value && attribute.value === selectedToggleValue) {
            selectedToggleAttribute = attribute;
          }
        });
      });
    }

    this.handleToggleValueSelected(selectedToggleAttribute);
  }

  cartContentChanged = (msg, cart) => {
    PubSub.publish(Constants.eventKeys.modalHideRetrieved, (cart.numberOfProducts > 0));
  }

  modalValueSelected = (msg, selectedToggleAttribute) => {
    this.handleToggleValueSelected(selectedToggleAttribute);
  }

  publishModalDetails() {
    if (this.props.toggleAttributeName && this.props.toggleText) {
      var modalDetails = {
        isOpen: this.state.userInputRequired,
        question: this.props.toggleText,
        answers: this.state.toggleAttributes,
        selectedAnswer: this.state.selectedToggleAttribute
      }
      PubSub.publish(Constants.eventKeys.modalContentRetrieved, modalDetails);
    }
  }

  handleToggleValueSelected = (selectedToggleAttribute) => {
    let deviceList = null;
    var userInputRequired = null;

    if (selectedToggleAttribute) {
      currentUser.setAttribute(this.props.toggleAttributeName, selectedToggleAttribute.value);

      // the toggle attribute is set and the value is set
      if (this.props.toggleAttributeName && this.props.toggleAttributeName && selectedToggleAttribute && selectedToggleAttribute.value) {
        deviceList = this.props.deviceLists.find(deviceList => deviceList.attributes.some(attribute => attribute.name && attribute.value && attribute.name.toUpperCase() === this.props.toggleAttributeName.toUpperCase() && selectedToggleAttribute.value.toUpperCase() === attribute.value.toUpperCase()));
      }
      userInputRequired = false;
    }
    else {
      if (this.state.toggleAttributes && this.state.toggleAttributes.length > 0) {
        selectedToggleAttribute = this.state.toggleAttributes[0];
      }
      userInputRequired = true;
    }

    this.setState({
      selectedToggleAttribute: selectedToggleAttribute,
      userInputRequired: userInputRequired
    });

    // fall back on the first list of offers
    if (!deviceList) {
      deviceList = this.props.deviceLists[0];
    }

    this.setState({
      deviceList: deviceList
    },
      this.getDeviceData);
  };

  async getDeviceData() {

    this.setState({
      isLoading: true
    });

    let attributes = this.state.deviceList.attributes.map(attribute => attribute.name + '=' + attribute.value).join('&');
    let dataUrl = this.props.dataUrl + '?' + attributes;
    let response = await fetch(dataUrl);
    let allDevices = await response.json();

    this.setState({
      allDevices: allDevices,
      filterOptions: this.getFilterOptions(allDevices),
      isLoading: false
    }, () => {
      this.sortAndFilter();
      this.publishModalDetails();
    });
  }

  getAllToggleAttributes() {
    let toggleAttributes = [];

    this.props.deviceLists.forEach(deviceList => {
      toggleAttributes = toggleAttributes.concat(deviceList.attributes.filter(attribute => attribute.name === this.props.toggleAttributeName));
    });

    return toggleAttributes;
  }

  getFilterOptions(devices) {
    var filterOptions = [{ key: 'all', value: 'All Brands', function: d => true }];

    devices.forEach(device => {
      let key = device.manufacturer.replace(/\s+/g, '').toLowerCase();

      if (filterOptions.filter(option => option.key == key).length == 0) {
        filterOptions.push({
          key: key,
          value: device.manufacturer,
          function: d => d.manufacturer == device.manufacturer
        });
      }
    });

    return filterOptions;
  }

  getSortOptions() {
    return [
      { key: 'default', value: 'Default' },
      { key: 'lth', value: 'Price (Low to High)', function: (a, b) => (a.fromPrice || a.price) - (b.fromPrice || b.price) },
      { key: 'htl', value: 'Price (High to Low)', function: (a, b) => (b.fromPrice || b.price) - (a.fromPrice || a.price) }
    ];
  }

  sortAndFilter() {
    let filterFunction = this.state.filterOptions.filter(option => option.key.toLowerCase() == this.state.selectedFilter).map(option => option.function)[0] || ((d) => true);
    let sortFunction = this.state.sortOptions.filter(option => option.key.toLowerCase() == this.state.selectedSort).map(option => option.function)[0];

    let filteredDevices = this.state.allDevices.filter(filterFunction);

    if (sortFunction) {
      filteredDevices.sort(sortFunction);
    }

    this.setState({
      filteredDevices: filteredDevices
    });
  }

  selectFilter = (value) => {
    this.setState({
      selectedFilter: value.key.toLowerCase()
    }, () => {
      this.sortAndFilter();
      this.setURL();
    });
  }

  selectSort = (value) => {
    this.setState({
      selectedSort: value.key.toLowerCase()
    }, () => {
      this.sortAndFilter();
      this.setURL();
    });
  }

  setURL() {
    let sortURL = Routing.getUrlWithoutQuery(window.location.href);
    if (this.state.selectedSort) {
      sortURL = Routing.addQueryParameter('sort', this.state.selectedSort.toLowerCase(), sortURL);
    }
    if (this.state.selectedFilter) {
      sortURL = Routing.addQueryParameter('filter', this.state.selectedFilter.toLowerCase(), sortURL);
    }
    history.replaceState({ id: 'query page' }, 'Device Listing', sortURL);
  }

  render() {
    let deviceList = this.props.deviceLists[0];
    let deviceType = deviceList.attributes.filter(attribute => attribute.name === "deviceType");
    let planType = deviceList.attributes.filter(attribute => attribute.name === "planType")[0].value;
    let dropDownCss = '';
    if (planType === 'PREPAY') {
      dropDownCss = 'mt-5 mb-5 d-flex sorting-container dropdown-margin';
    } else {
      dropDownCss = 'mt-5 mb-5 d-flex sorting-container';
    }
    if (this.state.error) {
      return (<h2 className="text-center">Error</h2>);
    }
    else if (this.state.isLoading) {
      return (<Loading className="m-5" />);
    }
    else if
      (this.state.allDevices == null || this.state.allDevices.length === 0) {
      return (<h2 className="text-center" />);
    }
    else if (deviceType[0].value === "MOBILE_BROADBAND") {
      return (
        <React.Fragment>
          <CartSummary {...this.props.cartSummary} className="container text-center" />
          <Container className="eir-device-list-container mt-6">
            <Row>
              {this.state.filteredDevices.map((device, index) =>
                <EirMBBDeviceListing
                  outOfStockForm={this.props.outOfStockForm}
                  ctaText={this.props.ctaText}
                  key={device.id + index}
                  theme={this.props.theme}
                  device={device} />
              )}
            </Row>
          </Container>
        </React.Fragment>
      );
    }
    else {
      return (
        <React.Fragment>
          <CartSummary {...this.props.cartSummary} className="container text-center" />
          {/* {planType === 'PREPAY' ? <EirPrepayPhoneToggle toggle='1' /> : ''} */}
          {planType === 'PREPAY' && !(window.location.href.includes("sim-free-phones")) ? <EirPrepayPhoneToggle toggle='1' /> : null}
          {/* {planType==='PREPAY'?this.dropDownCss='mt-5 mb-5 d-flex sorting-container dropdown-margin':this.dropDownCss='mt-5 mb-5 d-flex sorting-container'} */}
          <Container className={dropDownCss}>
            <EirDropdownList
              options={this.state.filterOptions}
              title="Brand"
              onClick={this.selectFilter}
              initialOption={this.state.filterOptions.filter(option => option.key == this.state.selectedFilter)[0]}
            />
            <EirDropdownList
              options={this.state.sortOptions}
              title="Sort By"
              onClick={this.selectSort}
              initialOption={this.state.sortOptions.filter(option => option.key == this.state.selectedSort)[0]}
            />
          </Container>
          <Container className="eir-device-list-container mt-6">
            {planType === 'PREPAY' ? <Row>
              {this.state.filteredDevices.map((device, index) =>
                <EirHandsetCard
                  outOfStockForm={this.props.outOfStockForm}
                  ctaText={this.props.ctaText}
                  key={device.id + index}
                  theme={this.props.theme}
                  device={device} />
              )}
            </Row> : <Row>
              {this.state.filteredDevices.map((device, index) =>
                <EirDeviceListing
                  ctaText={this.props.ctaText}
                  key={device.id + index}
                  theme={this.props.theme}
                  device={device} />
              )}
            </Row>}
            {/* <Row>

              {this.state.filteredDevices.map((device, index) =>
                // <EirDeviceListing
                //   ctaText={this.props.ctaText}
                //   key={device.id + index}
                //   theme={this.props.theme}
                //   device={device} />
                  <EirHandsetCard
                  outOfStockForm={this.props.outOfStockForm}
                  ctaText={this.props.ctaText}
                  key={device.id + index}
                  theme={this.props.theme}
                  device={device} />
              )}
            </Row> */}
          </Container>
        </React.Fragment>
      );
    }
  }
}


export default EirDeviceListContainer;
